<div *ngIf="error" class="alert alert-danger" role="alert">
  Unable to load the service map right now. Please try again later.
</div>
<app-service-map
  [accent]="'market-data'"
  [entries]="marketsList"
  [loading]="loading"
  [popupBuilder]="buildPopup"
  [pops]="commercialPopList"
  [title]="'Market Data Service Map'">
</app-service-map>
